module.exports = __webpack_public_path__ + "img/scholarship-example-desktop.9b30045.png";